<template>
    <div>
        <div class="form-group">
            <label>Channel ID</label>
            <input type="text" class="form-control" v-model="data.channelId">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {};
    }
}
</script>